import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    .company {
        background-color: ${vars.backgroundWhite};
        flex: 1 1 360px;
        width: 400px;
        border-radius: 0.4em;
        height: 30em;

        &__image {
            position: relative;
            height: 226px;
            min-width: 100%;

            img {
                border-radius: 0.4em 0.4em 0 0;
                overflow: hidden;
                object-fit: cover;
                height: 100%;
                min-width: 100%;
                max-width: 100%;
            }

            &__image {
                cursor: pointer;
            }
        }

        &__content {
            position: relative;
            padding: 2em;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 1.2em;
            height: calc(100% - 226px);

            &__title {
                font-size: 1.5em;
                font-weight: bold;
                max-width: 320px;
                margin: 0 auto 0.5em;
                cursor: pointer;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            &__description {
                font-size: 1em;
                font-weight: bold;
                max-width: 320px;
                margin: 0 auto 0.5em;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            &__more {
                margin-top: auto;
            }
        }
    }

    @media all and (max-width: ${vars.mobileL}) {
        .company {
            flex: 1 1 320px;
            max-width: 300px;
            height: 30em;

            &__image {
                height: 180px;
            }

            &__content {
                height: calc(100% - 180px);
            }
        }
    }
`;
